import React, { Component } from 'react';

declare var globalSns;

class ExtranetNavbar extends Component {
  constructor(props) {
    super(props);


    this.navigate = this.navigate.bind(this);
  }

  navigate(id, e) {
    this.props.onNavigate(id);
  }

  render() {
    return (
      <nav className="navbar navbar-fixed-top">
        <div className="row">
          <div className="col-sm-12">
            <div className="logo">
              <a href="./">
                <img src="/Search_Selection/assets/images/SNS_logo_extranet.png" alt="Search &amp; Selection" />
                <img src="/Search_Selection/assets/images/SNS_logo_extranet_mobile.png" alt="Search &amp; Selection" />
              </a>
            </div>
            <div className="menu">
              {
                this.props.menuitems.map((x) => 
                  x.showNav ? 
                    <div key={x.id} className={x.active ? "menuitem active": "menuitem"}>
                      <a onClick={(e) => this.navigate(x.id, e)}>
                        <i className={"fa " + x.className} title={x.title} aria-hidden="true"></i>
                        {x.active ? <span className="sr-only">(current)</span> : ""}
                        {x.nr ? <span>{x.nr}</span> : ""}
                      </a>
                    </div> : ""
                )
              }
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default ExtranetNavbar;


// WEBPACK FOOTER //
// ./src/Components/Extranet/ExtranetNavbar.js